// extracted by mini-css-extract-plugin
export default {"header":"Header_header__NLBcs","route":"Header_route__VMGLg","highlight":"Header_highlight__Zxp+E","iconContainer":"Header_iconContainer__Ihj9b","icon":"Header_icon__aGbj-"};